import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { useHistory } from 'react-router';
import {
  Backdrop,
  Dialog,
  DialogActions,
  DialogContent,
  Link,
  Typography,
  Button,
} from '@material-ui/core';

import { useStyles } from './styles';
import { Title } from 'src/components/Title';

function NewCadastroModal({ isAbertura, usuario }) {
  const history = useHistory();
  const classes = useStyles();

  const [open, setOpen] = useState(true);

  const closeModal = () => {
    setOpen(false);

    history.replace();
  };

  return (
    <>
      <div>
        <Dialog
          scroll="paper"
          aria-labelledby="scroll-dialog-title"
          aria-describedby="scroll-dialog-description"
          className={classes.modal}
          open={open}
          onClose={closeModal}
          closeAfterTransition
          BackdropComponent={Backdrop}
          BackdropProps={{
            timeout: 500,
          }}
        >
          <DialogContent dividers>
            <Title>Parabéns, {usuario}.</Title>

            {isAbertura ? (
              <>
                <Typography>
                  Você agora faz parte do ecossistema Imobitech.
                </Typography>
                <br />
                <Typography>
                  Agora precisamos que acesse a área de cliente e conclua o
                  cadastro da sua empresa para que possamos oferecer todo o
                  nosso pacote de serviços e benefícios.
                </Typography>
              </>
            ) : (
              <>
                <Typography>
                  Seja bem vindo ao Imobitech.
                  <br />
                  Você acaba de dar um grande passo em sua carreira
                  profissional!
                </Typography>
                <br />
                <Typography>
                  A partir de agora iremos iniciar a abertura da sua empresa e
                  você pode acompanhar todo o processo acessando a área do
                  cliente.
                </Typography>
              </>
            )}
            <br />
            <Typography>
              Qualquer dúvida, entre em contato pelos canais: <br />
              <strong>Whatsapp: </strong>
              <Link href="https://wa.me/5562995171445" target="_blank">
                (62) 99517-1445
              </Link>
              <br />
              <strong>E-mail: </strong>
              <Link
                href="mailto:contato@imobitechbrasil.com.br"
                target="_blank"
              >
                contato@imobitechbrasil.com.br
              </Link>
              <br />
              <strong>Site: </strong>
              <Link href="https://www.imobitechbrasil.com.br" target="_blank">
                www.imobitechbrasil.com.br
              </Link>
              <br />
              <strong>Instagram: </strong>
              <Link
                href="https://www.instagram.com/imobitech.brasil/"
                target="_blank"
              >
                @imobitech.brasil
              </Link>
            </Typography>
          </DialogContent>
          <DialogActions>
            <Button
              type="button"
              className={classes.ConfirmButton}
              onClick={closeModal}
            >
              CONTINUAR
            </Button>
          </DialogActions>
        </Dialog>
      </div>
    </>
  );
}

NewCadastroModal.propTypes = {
  isAbertura: PropTypes.bool.isRequired,
  usuario: PropTypes.string.isRequired,
};

export default NewCadastroModal;
